import { graphql } from 'react-relay';

import { DeliveryOrderWindowPaginator_query$key } from '../../../relay/__generated__/DeliveryOrderWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const DeliveryOrderWindowPaginator_query = graphql`
  fragment DeliveryOrderWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: DeliveryOrderFilter }
    order: { type: DeliveryOrderOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "DeliveryOrderWindowPaginatorRefreshQuery") {
    deliveryOrders(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...DeliveryOrderConnectionDataTable_deliveryOrderConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<DeliveryOrderWindowPaginator_query$key>, 'fragment'>;

const DeliveryOrderWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={DeliveryOrderWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.deliveryOrders.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default DeliveryOrderWindowPaginator;
